(() => {
  if (window.__kkFaqAccordionInitialized) return;
  window.__kkFaqAccordionInitialized = true;

  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;

      const group = details.closest('.faq-metaobject__items');
      if (!group) return;

      for (const sibling of Array.from(group.children)) {
        if (sibling !== details && sibling instanceof HTMLDetailsElement && sibling.open) {
          sibling.open = false;
        }
      }
    },
    true
  );
})();
